export default __webpack_public_path__ + "static/media/new-mailbox.00e7d9b0.svg";